import apiClient from '@/services/axios'

export async function put(payload) {
  var response = await apiClient.put('/catchoffers?enabled=' + payload)
  if (response) {
    return response.data
  }

  throw new Error('Unable to enable/disable catch offers.')
}